'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import cn from 'classnames';

import { ActionIcon } from 'src/shared/icons';
import { Logotype } from 'src/shared/components/logotype';
import { Typography } from 'src/shared/ui/Typography';

import styles from './index.module.css';

const ACTION_GROUP_URL = 'https://action.group/';

export const Header = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const recruitedId = searchParams.get('recruiter_id');
  const legalId = searchParams.get('legal_id');

  const hasNeedQueryParams = recruitedId && legalId;

  const isRecruiterRoute = pathname.includes('/admin');

  const handleLogotypeClick = () => {
    router.push(ACTION_GROUP_URL);
  };

  const renderContent = () => {
    if (isRecruiterRoute) {
      return (
        <>
          <Logotype href="/admin" />
          <div className={styles.nav}>
            <Typography view="semibold_14" href="/admin/agreements">
              Cогласия
            </Typography>
          </div>
        </>
      );
    }

    if (!hasNeedQueryParams) {
      return null;
    }

    return (
      <button type="button" className={styles.logotype} onClick={handleLogotypeClick} aria-label="Актион — на главную">
        <ActionIcon />
      </button>
    );
  };

  return (
    <div
      className={cn(styles.root, {
        [styles.rootCreamBackground]: !isRecruiterRoute,
        [styles.rootWhiteBackground]: isRecruiterRoute,
      })}
    >
      {renderContent()}
    </div>
  );
};
